import React from 'react';
import ConfirmSimpleModal from 'zoomforth_component_lib/confirm_simple_modal.jsx';

export default (props)=>
  <ConfirmSimpleModal 
    style={{width:500}}
    confirmButtonProps={{
      danger:true
    }} 
    {...props} 
  />;
